import { writable } from 'svelte/store';

export type NotificationType = 'error' | 'warning' | 'info';

export interface NotificationState {
	show: boolean;
	message: string;
	type: NotificationType;
	dismissible: boolean;
}

function createNotificationStore() {
	const { subscribe, set, update } = writable<NotificationState>({
		show: false,
		message: '',
		type: 'info',
		dismissible: true
	});

	return {
		subscribe,
		showError: (message: string, dismissible = true) => {
			set({ show: true, message, type: 'error', dismissible });
		},
		showWarning: (message: string, dismissible = true) => {
			set({ show: true, message, type: 'warning', dismissible });
		},
		showInfo: (message: string, dismissible = true) => {
			set({ show: true, message, type: 'info', dismissible });
		},
		hide: () => {
			update((state) => ({ ...state, show: false }));
		},
		clear: () => {
			set({ show: false, message: '', type: 'info', dismissible: true });
		}
	};
}

export const notificationBanner = createNotificationStore();

// Helper function for direct access
export function showNotification(
	message: string,
	type: NotificationType = 'info',
	dismissible = true
) {
	notificationBanner[
		type === 'error' ? 'showError' : type === 'warning' ? 'showWarning' : 'showInfo'
	](message, dismissible);
}

export function hideNotification() {
	notificationBanner.hide();
}
